import React, {useEffect, useState} from 'react';
import {NavLink, useNavigate} from "react-router-dom";
import {useAuthorizationStateValue} from "../../../account/context";
import {useLocation} from "react-use";
import parse from "html-react-parser";
import {useForm} from "react-hook-form";

const PlacanjeUspjesno = (props) => {
    const {register, handleSubmit, setValue, getValues} = useForm();
    const [inputInvalid, setInputInvalid] = useState(true);
    const {isAuthorized, tokenData} = useAuthorizationStateValue();
    const [selectedPlan, setSelectedPlan] = useState({});
    const [selectedCard, setSelectedCard] = useState(null);

    let navigate = useNavigate();
    let location = useLocation();

    return (
        <div id="subscriptionConfirmationPage" className="lightContent">
            <div className="subscribeSuccessArea">
                <div className="mainTitleLeft">
                    <div className="mainTitle">Čestitamo!</div>
                    <div className="mainSubtitle"><br />Tvoja <b>ON TV</b> pretplata je uspješno produžena.</div>
                </div>
                <NavLink className="backToAccount" to={"/nalog"}>&lt; Nazad na moj nalog</NavLink>
            </div>



        </div>
    )
};

export default PlacanjeUspjesno;